import {useRef } from 'react';

export const useTouchDetect = () => {
    const isTouch = useRef(typeof window === "undefined" ? false : ("ontouchstart" in document.documentElement));
    return isTouch.current;
};
